import { InfoOutline } from '@mui/icons-material'
import Tooltip from '@mui/material/Tooltip'
import React, { ReactElement} from 'react'
import styled from 'styled-components'

const StyledInlineContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.25em;
`

type FractionNonMissingTooltipProps = {
    fraction: number | undefined;
    children: ReactElement;
}

const FractionNonMissingTooltip = ({fraction, children}: FractionNonMissingTooltipProps) => {
    return <Tooltip title={fraction !== undefined ? `Fraction non missing: ${fraction}` : ''} placement="top-start">
        <StyledInlineContainer>
            {children}
            <InfoOutline fontSize="small"/>
        </StyledInlineContainer>
    </Tooltip>
}

export default FractionNonMissingTooltip